import script from "./ConsumerMypageEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerMypageEditView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__